module.exports = __webpack_public_path__ + "img/pano_6.6dd207d7.jpg";